import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";

class AdminopeningsController {
  constructor($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
    this.name = "adminopenings";
    $localStorage.activeStateName = "adminopenings";

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$timeout = $timeout;

    this.weeklyOpenings = [];
    this.monthlyOpenings = [];
    this.yearlyOpenings = [];
    this.graphCategories = [];
    this.graphData = [];

    this.remain_loading_count = 0;
    this.currentUser = this.$auth.getUserData();

    var _this = this;

    // weekly openings: 0, monthly openings: 1, yearly openings: 2
    _this.chartType = "line";
    _this.openingType = 0;
    _this.weeklyView();
    $("adminsidebar .sidebar-nav li:nth-child(5)").removeClass().addClass("active");
  }

  drawChart(chartType = "line") {
    var type = "area";
    this.chartType = "line";
    if (chartType !== "line") {
      type = "column";
      this.chartType = "bar";
    }
    $("#transactions-graph").highcharts({
      chart: {
        type: type,
      },
      title: {
        text: "",
        align: "left",
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        categories: this.graphCategories,
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          formatter: function () {
            return this.value;
          },
        },
      },
      tooltip: {
        backgroundColor: "#69b747",
        headerFormat: "",
        pointFormat: "{point.y}",
        borderRadius: 20,
        style: {
          color: "#ffffff",
        },
      },
      plotOptions: {
        area: {
          fillOpacity: 0,
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "null",
          data: this.graphData,
        },
      ],
    });
  }

  weeklyView() {
    var _this = this;
    _this.openingType = 0;
    _this.weeklyOpenings = [];
    var startDate = moment().utcOffset("-0400").startOf("week").format();
    var endDate = moment().utcOffset("-0400").endOf("week").format();
    _this.remain_loading_count++;

    _this.$auth.getOpenings(startDate, endDate, "1d").then(
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
        var count;
        var dayOpening;
        var indexSplit;
        for (var i = 0; i < Object.keys(response.data).length; i++) {
          count = response.data[Object.keys(response.data)[i]];
          dayOpening = {};
          indexSplit = Object.keys(response.data)[i].indexOf("--");
          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));

          dayOpening.date = tempStartDate.format("MMM DD, YYYY");
          dayOpening.count = count;
          dayOpening.graphDate = tempStartDate.format("MMM DD");
          dayOpening.graphData = count;
          _this.weeklyOpenings.push(dayOpening);
        }

        _this.graphCategories = [];
        _this.graphData = [];
        _this.weeklyOpenings.forEach(function (dayOpening) {
          _this.graphCategories.push(dayOpening.graphDate);
          _this.graphData.push(dayOpening.graphData);
        });
        _this.drawChart(_this.chartType);

        console.log(_this.weeklyOpenings);
      },
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  monthlyView() {
    var _this = this;
    _this.openingType = 1;
    _this.monthlyOpenings = [];
    var startDate = moment().utcOffset("-0400").startOf("month").format();
    var endDate = moment().utcOffset("-0400").endOf("month").format();
    _this.remain_loading_count++;

    _this.$auth.getOpenings(startDate, endDate, "1w").then(
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
        var count;
        var weekOpening;
        var indexSplit;
        for (var i = 0; i < Object.keys(response.data).length; i++) {
          count = response.data[Object.keys(response.data)[i]];
          weekOpening = {};
          indexSplit = Object.keys(response.data)[i].indexOf("--");
          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));

          weekOpening.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
          weekOpening.count = count;
          weekOpening.graphDate = tempStartDate.format("MMM DD");
          weekOpening.graphData = count;
          _this.monthlyOpenings.push(weekOpening);
        }

        _this.graphCategories = [];
        _this.graphData = [];
        _this.monthlyOpenings.forEach(function (weekOpening) {
          _this.graphCategories.push(weekOpening.graphDate);
          _this.graphData.push(weekOpening.graphData);
        });
        _this.drawChart(_this.chartType);

        console.log(_this.monthlyOpenings);
      },
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  yearlyView() {
    var _this = this;
    _this.openingType = 2;
    _this.yearlyOpenings = [];
    var startDate = moment().utcOffset("-0400").startOf("year").format();
    var endDate = moment().utcOffset("-0400").endOf("year").format();
    _this.remain_loading_count++;

    _this.$auth.getOpenings(startDate, endDate, "1m").then(
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
        var count;
        var monthOpening;
        var indexSplit;
        for (var i = 0; i < Object.keys(response.data).length; i++) {
          count = response.data[Object.keys(response.data)[i]];
          monthOpening = {};
          indexSplit = Object.keys(response.data)[i].indexOf("--");
          var tempStartDate = moment(Object.keys(response.data)[i].substring(0, indexSplit));
          var tempEndDate = moment(Object.keys(response.data)[i].substring(indexSplit + 2));

          monthOpening.date = tempStartDate.format("MMM DD, YYYY") + " - " + tempEndDate.format("MMM DD, YYYY");
          monthOpening.count = count;
          monthOpening.graphDate = tempStartDate.format("MMM DD");
          monthOpening.graphData = count;
          _this.yearlyOpenings.push(monthOpening);
        }

        _this.graphCategories = [];
        _this.graphData = [];
        _this.yearlyOpenings.forEach(function (monthOpening) {
          _this.graphCategories.push(monthOpening.graphDate);
          _this.graphData.push(monthOpening.graphData);
        });
        _this.drawChart(_this.chartType);

        console.log(_this.yearlyOpenings);
      },
      function (response) {
        _this.remain_loading_count--;
        console.log(response.data);
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }
}

AdminopeningsController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];

export default AdminopeningsController;



// WEBPACK FOOTER //
// ./client/app/components/adminopenings/adminopenings.controller.js